import { NavLink, Link } from "react-router-dom";
import { useState } from "react";
import { Moon, Sun, Menu, X, BookOpen } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const links = [
  { to: "/sozluk", label: "Sözlük", testid: "nav-dictionary-link" },
  { to: "/harita", label: "Dairevi Harita", testid: "nav-map-link" },
  { to: "/savlar", label: "Savlar", testid: "nav-proverbs-link" },
  { to: "/zaman", label: "Zaman Yolu", testid: "nav-timeline-link" },
  { to: "/oyun", label: "Kelime Avı", testid: "nav-quiz-link" },
  { to: "/hakkinda", label: "Hakkında", testid: "nav-about-link" },
];

export const Header = () => {
  const { theme, toggle } = useTheme();
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `relative px-1 py-2 text-sm tracking-wide transition-colors ${
      isActive ? "rubric font-semibold" : "text-foreground/70 hover:text-foreground"
    }`;

  return (
    <header
      data-testid="main-nav"
      className="sticky top-0 z-50 backdrop-blur-md bg-background/90 border-b border-border"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
            <span className="flex items-center justify-center w-10 h-10 rounded-full border border-accent/60 text-accent group-hover:bg-accent/10 transition-colors">
              <BookOpen className="w-5 h-5" />
            </span>
            <span className="leading-tight">
              <span className="block font-[Cinzel] text-base sm:text-lg font-bold tracking-wide text-foreground">
                Divânu Lugâti't-Türk
              </span>
              <span className="block eyebrow text-[0.6rem]">Dijital El Yazması Codex</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-5">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} className={linkClass} data-testid={l.testid}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={toggle}
              data-testid="theme-toggle-btn"
              aria-label="Tema değiştir"
              className="flex items-center justify-center w-10 h-10 rounded-full border border-border hover:border-accent text-foreground/80 hover:text-accent transition-colors"
            >
              {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </button>
            <button
              onClick={() => setOpen((o) => !o)}
              data-testid="mobile-menu-btn"
              aria-label="Menü"
              className="lg:hidden flex items-center justify-center w-10 h-10 rounded-full border border-border text-foreground/80"
            >
              {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-border bg-background/95 px-4 py-3 flex flex-col">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="py-3 border-b border-border/50 text-foreground/80"
              data-testid={`${l.testid}-mobile`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
